import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/tasks/$taskId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/app/tasks',
      search: { openTaskId: params.taskId, tab: search.tab },
    });
  },
});
